import React, { useEffect, useRef } from "react";

type IProps = {
  paths: AMap.LngLatLike[] | AMap.LngLatLike[][]
}

const NavRouteViewer = (props: IProps) => {

  const map = useRef<AMap.Map | undefined>()

  // 初始化地图
  React.useEffect(() => {

    let Timer: NodeJS.Timeout|null = null;

    const init = () => {
      if (!window.AMap) {
        Timer = setTimeout(init, 100);
        return;
      }

      try {
        let GY: [number, number] = [106.648957, 26.648632]//贵阳地址
        let center: [number, number] = GY
        const map1 = new window.AMap.Map("nav_viewer", {
          viewMode: "3D",
          center: center,
          zoom: 10,
        });

        const traffic = new window.AMap.TileLayer.Traffic({
          zIndex: 10,
        });

        map1.add(traffic);
        map.current = map1;



      } catch (e) {
        console.log(e);
      }
    }

    Timer = setTimeout(init, 100)

    return () => {
      if (Timer) {
        clearTimeout(Timer)
      }
    }
  }, []);


  const showPolylines = React.useCallback((polyline: AMap.Polyline) => {

    if (!map.current) return;

    let useMap = map.current

    if (!polyline) return;

    useMap.add([polyline]);

    // 显示并且居中
    polyline.show();
    polyline.visible = true;
    useMap.setFitView([polyline]);
  }, [])

  useEffect(() => {

    if (!props.paths || props.paths.length < 1) {
      return;
    }
    let polyline = new window.AMap.Polyline({
      path: props.paths,
      isOutline: true,
      outlineColor: '#ffeeff',
      borderWeight: 3,
      strokeColor: "#3366FF",
      strokeOpacity: 1,
      strokeWeight: 6,
      strokeStyle: "solid",
      strokeDasharray: [10, 5],
      lineJoin: 'round',
      lineCap: 'round',
      zIndex: 50,
    })

    const addMarker = (posi: AMap.Vector2, type: number) => {
       // 起点 Icon
      const startIcon = new window.AMap.Icon({
        size: new window.AMap.Size(25, 34),
        image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
        imageSize: new window.AMap.Size(135, 40),
        imageOffset: new window.AMap.Pixel(-9, -3)
      });

      const startMarker = new window.AMap.Marker({
        position: posi,
        icon: startIcon,
        offset: new window.AMap.Pixel(-13, -30)
      });

      // 终点 icon
      const endIcon = new window.AMap.Icon({
          size: new window.AMap.Size(25, 34),
          image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
          imageSize: new window.AMap.Size(135, 40),
          imageOffset: new window.AMap.Pixel(-95, -3)
      });

      const endMarker = new window.AMap.Marker({
          position: posi,
          icon: endIcon,
          offset: new window.AMap.Pixel(-13, -30)
      });
      if (type === 0) {
        map.current?.add([startMarker])
      } else {
        map.current?.add([endMarker])
      }

    }

    const init = () => {

      if (!map.current) {
        setTimeout(init, 200)
        return
      }

      showPolylines(polyline);

      let start = props.paths[0]
      let end = props.paths[props.paths.length - 1]

      if (Array.isArray(start)) {
        if (start.length === 2 && typeof start[0] === "number") {
          addMarker(start as AMap.Vector2, 0)
        }
      }

      if (Array.isArray(end)) {
        if (end.length === 2 && typeof end[0] === "number") {
          addMarker(end as AMap.Vector2, 1)
        }
      }
    }

    setTimeout(init, 200)

  }, [props.paths])

  return <div id="nav_viewer" className="width-100P height-640px"></div>
}

export default NavRouteViewer